// extracted by mini-css-extract-plugin
export default {"content":"addFromMarketMapModal_content__hRf5-","button":"addFromMarketMapModal_button__KV2vW"};